import React, { useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TextStyles from "../../../components/Elements/TextStyles/TextStyles";
import { ReactComponent as BackIcon } from "../../../assets/svgs/back-button.svg";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";

import CardsBorder from "../../../components/Cards/CardsBorder";
import CustomerReportBasicDetails from "./CustomerReportBasicDetails";
import Reports from "./Reports";
import StandardForms from "./StandardForms";
import DynamicForms from "./DynamicForms";

const CustomerReportsDetails = () => {
const [refreshReports, setRefreshReports] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { clientId, projectId } = location.state || {};
   console.log("Details", clientId, projectId);
    const handleReloadReports = useCallback(() => {
   
    setRefreshReports(prev => !prev);
  }, []);
  return (
    <div>
      <div className="mx-10 mt-4">
        <div
          className="flex justify-end  text-xs"
          style={{ fontFamily: "Calibri" }}
        >
          <p>Home </p>
          <span> / </span>
          <p>Customer Reports </p> <span> / </span>
          <TextStyles color="gradient"> Customer Report Details</TextStyles>
        </div>
        <div className="flex justify-between ">
          <div className="flex my-auto ">
            <BackIcon
              onClick={() => {
                navigate(-1);
              }}
            />

            <div>
              <TextStyles color="gradient" style={{ fontSize: "20px" }}>
                <p className=" mt-3"> Customer Reports </p>
              </TextStyles>
            </div>
          </div>
          {/* <div>
            <CustomButton
              buttonType="primary"
              variant="ok"
              buttonText="LOGIN AS A USER"
              className="text-sm h-[50px]"
              // onClick={handleOpenAddNew}
            />
          </div> */}
        </div>
        <div>
          <CustomerReportBasicDetails onReloadReports={handleReloadReports}/>
        </div>
        <div className="my-8">
          <Reports refresh={refreshReports} />
        </div>
        <div className="my-8">
          <StandardForms projectId={projectId} clientId={clientId} />
        </div>
        <div className="my-8">
          <DynamicForms projectId={projectId} clientId={clientId} />
        </div>
      </div>
    </div>
  );
};

export default CustomerReportsDetails;
